module.exports = __webpack_public_path__ + "static/media/Portrait-10225.64268e0e.jpg";